<template>
  <div></div>
</template>
<script>
import { CLAIM_CONTENT } from '@/store/types'
export default {
  name: 'Claim',
  data() {
    return {
      type: this.$route.params.type,
      code: this.$route.query.code,
      typeMap: {
        instructorcopy: 'deskcopy',
        gift: 'gift',
        trial: 'trial'
      }
    }
  },
  mounted() {
    const apiType = this.typeMap[this.type]

    if (!apiType || !this.code) {
      console.warn('잘못된 접근입니다.')
      alert('잘못된 접근입니다.')
      this.$router.push({ name: 'store' })
      return
    }

    this.$store
      .dispatch(CLAIM_CONTENT, { type: apiType, code: this.code })
      .then((res) => {
        if (res.data.ok) {
          // console.log('테스트 - 성공라인')
          alert(
            '전자책 등록이 완료되었습니다. \n 받은 전자책은 바로 확인하실 수 있어요.'
          )
          this.$router.push({ name: 'library_default' })
        }
      })
      .catch((err) => {
        if (err.response.data.errorState.reason === 'INVALID_MEMBER_TP') {
          // 교강사 x
          alert(
            '이 도서는 교강사 회원에게만 제공됩니다. \n회원유형을 확인한 후 다시 시도해 주세요.'
          )
        } else if (err.response.data.errorState.reason === 'DUPLICATE_BOOK') {
          // 기등록
          alert('이미 등록된 링크입니다. \n링크를 다시 한 번 확인해주세요.')
        } else if (err.response.data.errorState.reason === 'INVALID_COUPON') {
          // 유효하지 않은 링크
          alert(
            '유효하지 않은 링크입니다. \n올바른 링크인지 다시 확인해 주세요.'
          )
        } else {
          alert(
            '유효하지 않은 링크입니다. \n올바른 링크인지 다시 확인해 주세요.'
          )
        }
        this.$router.push({
          name: 'library_default'
        })
      })
  }
}
</script>
<style lang="scss" scoped></style>
